
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.857 4.09a.5.5 0 010 .7l-3.18 3.19a.5.5 0 11-.7-.71l2.31-2.33H.507v-1h6.8l-2.34-2.33a.5.5 0 01.71-.7l3.18 3.17v.01z","fill":"#000"}})])
          )
        }
      }
    